// extracted by mini-css-extract-plugin
module.exports = {"fieldLable":"DataExpressionDetails_fieldLable__2h-kA"};